module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "Aut"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Aut",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Author’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("I do not look on all the characters in these stories as bad; some of them do have wicked hearts, but as many of them are victims. Emily Vanderpool, who narrates the title story and who acknowledges that she has a bad character, is someone I knew well as a child; indeed, I often occupied her skin and, looking back, I think that while she was notional and stubborn and a trial to her kin, her talent for iniquity was feeble—she wanted to be a road-agent but she hadn’t a chance. Her troubles stemmed from the low company she kept, but she did not seek these parties out: they found her. It is a widespread human experience. The strenuous young man in “A Reasonable Facsimile” is not bad, he is merely poisonous and the sociologist in “Caveat Emptor” is, by reason of his calling, awful and to be avoided at all cost but he isn’t bad. The personification of rectitude, Judge Bay, who appears in several of the stories, and Landlady Placer in “In the Zoo” go on my black list which is headed by the name of Frau Professor Galt in the short novel, “A Winter’s Tale.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Except for “Caveat Emptor,” which appeared in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Mademoiselle,")]), _vm._v(" “The Captain’s Gift” in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Sewanee Review,")]), _vm._v(" and “A Winter’s Tale” in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("New Short Novels")]), _vm._v(" (Ballantine Books), all of these stories originally came out in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The New Yorker.")])]), _vm._v(" "), _c('p', {
    staticClass: "ausig"
  }, [_c('a', {
    attrs: {
      "href": "http://us.macmillan.com/author/jeanstafford?utm_source=ebook&utm_medium=adcard&utm_term=ebookreaders&utm_content=jeanstafford_authorpage_macdotcom&utm_campaign=9781466896581",
      "target": "_blank"
    }
  }, [_vm._v("Jean Stafford")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73a0de68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/authorsnote.vue
// module id = 69
// module chunks = 0